import { AnonymousLayout } from "Components/Layout/AnonymousLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { TransactionDetail } from "Components/Transactions/Anonymous/TransactionDetail";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Navigate } from "Navigation/Navigate";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";
import { Resources, useResource } from "Translations/Resources";
import { useCampaignData } from "Hooks/useCampaignData";
import { getCampaignLogo } from "Utils/CampaignLogo";

export const AnonymousTransactionDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useResource();
  const campaignCode = useCampaignData(id || "");
  const campaignLogo = getCampaignLogo(campaignCode);

  if (!id) {
    // this should never happen, but just in case
    return <Navigate to={appUrl("sign-in")} replace />;
  }

  return (
    <AnonymousLayout
      title={t(Resources.Pages.Titles.AnonymousTransactionDetail)}
      secondaryLogo={campaignLogo}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <PrimaryPaper sx={{ overflow: "hidden", mt: 0 }}>
            <TransactionDetail transactionPublicID={id} />
          </PrimaryPaper>
        </div>
      </StyledPageWrapper>
    </AnonymousLayout>
  );
};
